module.exports = __webpack_public_path__ + "img/delivery.50d8e7d4.svg";